document.addEventListener("DOMContentLoaded", function () {
  /**
   * Toggle video playback
   * @param {HTMLVideoElement} video
   * @param {boolean} isPaused
   */
  const toggleVideoPlayback = (video, isPaused) => {
    if (isPaused) {
      void video.play();
    } else {
      video.pause();
    }
  };

  /**
   * Toggle video sound
   * @param {HTMLVideoElement} video
   * @param {boolean} isMuted
   */
  const toggleVideoSound = (video, isMuted) => {
    video.muted = !isMuted;
  };

  /** @type {NodeListOf<HTMLDivElement>} */
  const controlsWrappers = document.querySelectorAll(".hero__video-controls");
  controlsWrappers.forEach(function (wrapper) {
    const section = wrapper.closest(".shopify-section");
    if (!section) return;
    /** @type {NodeListOf<HTMLVideoElement>} */
    const videos = section.querySelectorAll('video[id*="HeroVideo"]');
    if (videos.length === 0) return;
    /** @type {NodeListOf<HTMLButtonElement>} */
    const controls = wrapper.querySelectorAll(".hero__video-control");

    // Helper to detect which video is actually visible per CSS (avoid fighting CSS with JS)
    const isVisible = (el) => {
      const cs = window.getComputedStyle(el);
      if (
        cs.display === "none" ||
        cs.visibility === "hidden" ||
        cs.opacity === "0"
      )
        return false;
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    };

    // Pick the currently visible video; fallback to first
    const pickActiveCandidate = () => {
      const visible = Array.from(videos).find(isVisible);
      return /** @type {HTMLVideoElement} */ (visible || videos[0]);
    };

    let activeVideo = pickActiveCandidate();

    // Remove Shopify video_tag fallback anchors that may render filenames (e.g., template--...hero_...)
    /** @param {HTMLVideoElement} videoEl */
    const cleanupFallbackAnchors = (videoEl) => {
      /** @param {HTMLAnchorElement} a */
      const isMediaLink = (a) => {
        const href = a.getAttribute("href") || "";
        return /template--|\.mp4$|\.webm$|\.m3u8$|cdn\.shopify\.com\/videos\//.test(
          href,
        );
      };
      // Sibling anchors next to the video
      let sib = videoEl.nextElementSibling;
      while (sib && sib.tagName === "A" && isMediaLink(sib)) {
        sib.remove();
        sib = videoEl.nextElementSibling;
      }
      // Anchors within the same container
      const container = videoEl.parentElement;
      if (container) {
        container.querySelectorAll("a").forEach((a) => {
          if (isMediaLink(a)) a.remove();
        });
      }
    };

    cleanupFallbackAnchors(activeVideo);

    // Sync initial states so icons match video state on first render
    // (removed stray broken lines)

    /**
     * @param {HTMLVideoElement} video
     */
    const syncStates = (video) => {
      controls.forEach(function (control) {
        const controlAttr = control.getAttribute("data-video-control");
        if (controlAttr === "pause") {
          const isPaused = video.paused;
          control.dataset.state = isPaused ? "play" : "pause";
          if (control.dataset.playLabel && control.dataset.pauseLabel) {
            control.setAttribute(
              "aria-label",
              isPaused ? control.dataset.playLabel : control.dataset.pauseLabel,
            );
          }
        } else if (controlAttr === "mute") {
          const isMuted = video.muted;
          control.dataset.state = isMuted ? "mute" : "unmute";
          if (control.dataset.unmuteLabel && control.dataset.muteLabel) {
            control.setAttribute(
              "aria-label",
              isMuted ? control.dataset.unmuteLabel : control.dataset.muteLabel,
            );
          }
        }
      });
    };

    // Sync initial states for the active video only
    syncStates(activeVideo);

    // Keep button state in sync with actual video events
    const syncFromEvent = () => syncStates(activeVideo);
    /** @param {HTMLVideoElement} video */
    const attachVideoEvents = (video) => {
      video.addEventListener("playing", syncFromEvent);
      video.addEventListener("play", syncFromEvent);
      video.addEventListener("pause", syncFromEvent);
      video.addEventListener("ended", syncFromEvent);
      video.addEventListener("loadedmetadata", syncFromEvent);
      video.addEventListener("canplay", syncFromEvent);
    };
    /** @param {HTMLVideoElement} video */
    const detachVideoEvents = (video) => {
      video.removeEventListener("playing", syncFromEvent);
      video.removeEventListener("play", syncFromEvent);
      video.removeEventListener("pause", syncFromEvent);
      video.removeEventListener("ended", syncFromEvent);
      video.removeEventListener("loadedmetadata", syncFromEvent);
      video.removeEventListener("canplay", syncFromEvent);
    };
    attachVideoEvents(activeVideo);

    // On resize, re-evaluate which video is active and sync states
    const resizeObserver = () => {
      const current = pickActiveCandidate();
      if (current && current !== activeVideo) {
        // Pause and mute the previous active to avoid audio overlap
        try {
          activeVideo.pause();
        } catch (e) {}
        activeVideo.muted = true;
        detachVideoEvents(activeVideo);
        activeVideo = current;
        cleanupFallbackAnchors(activeVideo);
        syncStates(activeVideo);
        attachVideoEvents(activeVideo);
      }
    };
    window.addEventListener("resize", resizeObserver);

    controls.forEach(function (control) {
      control.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const btn = /** @type {HTMLButtonElement} */ (event.currentTarget);
        const controlAttr = btn.getAttribute("data-video-control");
        if (controlAttr === "pause") {
          toggleVideoPlayback(activeVideo, activeVideo.paused);
          btn.dataset.state = activeVideo.paused ? "play" : "pause";
          if (btn.dataset.playLabel && btn.dataset.pauseLabel) {
            btn.setAttribute(
              "aria-label",
              activeVideo.paused
                ? btn.dataset.playLabel
                : btn.dataset.pauseLabel,
            );
          }
        } else if (controlAttr === "mute") {
          toggleVideoSound(activeVideo, activeVideo.muted);
          btn.dataset.state = activeVideo.muted ? "mute" : "unmute";
          if (btn.dataset.unmuteLabel && btn.dataset.muteLabel) {
            btn.setAttribute(
              "aria-label",
              activeVideo.muted
                ? btn.dataset.unmuteLabel
                : btn.dataset.muteLabel,
            );
          }
        }
      });
    });
  });
});
